import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PortalModule } from '@angular/cdk/portal';
import { OverlayModule } from '@angular/cdk/overlay';
import { CameraComponent } from './camera.component';
import { CameraService } from './camera.service';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacySliderModule as MatSliderModule } from '@angular/material/legacy-slider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TranslateModule } from '@ngx-translate/core';
import { CameraConviteComponent } from './camera-convite.component';
import { AbCamera } from 'app/abstract/camera/camera.abstract';

@NgModule({
    imports: [
        CommonModule,
        PortalModule,
        OverlayModule,
        MatToolbarModule,
        MatButtonModule,
        MatIconModule,
        MatSliderModule,
        TranslateModule
    ],
    declarations: [
        CameraComponent,
        CameraConviteComponent
    ],
    providers: [
        {
            provide: AbCamera,
            useClass: CameraService
        }
    ]
})
export class CameraModule { }
